<img class="tw-h-4.5 tw-shrink-0"
  src="/assets/images/warn-err.png"
  alt="warning" />
<div class="tw-ml-1 tw-text-100 tw-text-orange-500">
  <ng-content></ng-content>
</div>
